import { forwardRef } from 'react';
import { phoneDigits, PHONE_HINT } from '@hfb/shared';
import Input from './Input.jsx';

/**
 * One phone field for every form: a +91 mobile, typed as 10 digits.
 *
 * Anything that isn't a digit is dropped as the person types (so a pasted
 * "+91 98765-43210" lands correctly), the keypad opens on phones, and the
 * value handed back is the plain digits — normalisePhone() turns that into
 * what the API stores.
 */
const PhoneField = forwardRef(function PhoneField(
  { value, onChange, label = 'Mobile number', error, hint, required = true, name = 'phone', ...props },
  ref,
) {
  const digits = String(value ?? '').replace(/\D/g, '');
  // A pasted number with 91 or a leading 0 still shows as the 10 that count.
  const shown = digits.length > 10 ? (phoneDigits(digits) ?? digits.slice(-10)) : digits;

  return (
    <Input
      ref={ref}
      label={required ? label : `${label} (optional)`}
      type="tel"
      inputMode="numeric"
      autoComplete="tel"
      name={name}
      maxLength={10}
      placeholder="98765 43210"
      prefix="+91"
      className="pl-14"
      value={shown}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 10))}
      error={error}
      hint={error ? undefined : hint ?? PHONE_HINT}
      aria-required={required || undefined}
      {...props}
    />
  );
});

export default PhoneField;
